import { toast } from "react-toastify";

type Translate = (key: any, options?: any) => string;

// Copy text and tell the user what actually happened. The Clipboard API is
// absent outside secure contexts (plain http) and its write can be refused by
// permissions, so a bare `writeText` either throws synchronously or rejects —
// in both cases a "copied" toast would be a lie.
export const copyToClipboard = async (text: string, t: Translate, label?: string): Promise<boolean> => {
    const success = () => toast.info(
        label ? `${label} ${t("copied to clipboard")}` : `${t("copied to clipboard")}`,
        { position: toast.POSITION.TOP_RIGHT, autoClose: 2000 });
    const failure = () => toast.error(
        `${t("Could not copy to clipboard")}`,
        { position: toast.POSITION.TOP_RIGHT, autoClose: 2000 });

    if (!navigator.clipboard?.writeText) {
        failure();
        return false;
    }
    try {
        await navigator.clipboard.writeText(text);
        success();
        return true;
    } catch {
        failure();
        return false;
    }
};
